$(window).scroll(function() {
  if ($(this).scrollTop() >= 50) {
      $('#return-to-top').fadeIn(200);
  } else {
      $('#return-to-top').fadeOut(200);
  }
});

$(document).ready(function() {
  $(document.body).click(function(e) {
    if (e.target.id == "return-to-top" || e.target.parentNode.id == "return-to-top"){
      $('html, body').animate({scrollTop : 0}, 500);
      event.preventDefault();
    }
  });
});
